import { useEffect, useState } from "react"
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _AdquisitionItem, _AdquisitionItemBudgetID } from "../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { AdquisitionItemSelector } from "../../../../contract/etapa-contrato/contrac/ublinvoice/AdquisitionItemEditor/AdqusitionItemSelector";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../theme/Component/PrintJson";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}
export const BPM004 = ({ configProcedure }: Props) => {

    const props = configProcedure?._pocessData?.Props ?? {};

    const { bean, setBean, instance } = useDataBean(_AdquisitionItem);
    const _budget = useDataBean(_AdquisitionItemBudgetID);
    const [invalid, setInvalid] = useState<boolean>(false);
    const [editedBudgetList, setEditedBudgetList] = useState<any[]>([]);

    useEffect(() => {
        setBean({
            obs: ''
        });
    }, [])

    const saveSupplier = () => {
        console.log(editedBudgetList)
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(bean.obs)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap({ ...bean, HasProject: bean.IDProject ? 1 : 2 })
        }

        if (configProcedure?._pushProps) {
            configProcedure._pushProps({
                ...bean,
                budgetList: JSON.stringify(editedBudgetList),
                ...(props?.IDBoss != null
                    ? { AssignTo: props.IDBoss }
                    : {})
            });
        }
    }

    useEffect(() => {
        if (bean.IDAdquisitionItem) {
            getBudget(bean.IDAdquisitionItem);
        }
    }, [bean.IDAdquisitionItem])

    const getBudget = (idItem: number) => {
        _budget.instance.getAdquisitionItemBudgetIDCatalog(idItem).then(
            (resp) => {
                _budget.setLista(resp);
                setEditedBudgetList([...resp]);
            }
        ).catch(
            err => {
                console.log(err)
                toast.error("No se pudo cargar los rubros")
            }
        )
    }

    const head = [
        { title: 'ID', property: "IDAdquisitionItemBudgetID", mask: MASK_NUMBER },
        { title: 'Codigo Rubro', property: 'JsonCode' },
        { title: 'Nombre Rubro', property: 'BudgetName' },
        { title: 'Recurso', property: 'NameResource' },
        { title: 'Valor Estimado', property: 'EstimatedValue', mask: MASK_MONEY },
        { title: 'PI', property: 'PIValue', mask: MASK_MONEY },
        { title: 'Valor Restante', property: 'LeftValue', mask: MASK_MONEY },
        // { title: 'CDP', property: 'CDPValue', mask: MASK_MONEY },
        // { title: 'RCDP', property: 'RCDPValue', mask: MASK_MONEY },
        // { title: 'Saldo CDP', property: 'LeftValue', mask: MASK_MONEY, visible: true },
        // { title: 'Funcionario', property: 'EmployeeName', visible: false },
        // { title: 'Observaciones', property: 'Description', visible: false },
    ]


    return (
        <div className="row">
            <div className="col-12">
                <AdquisitionItemSelector ConfigProps={{ filterState: 6, disable: props.IDAdquisitionItem ? true : false }} idAdquisitionItem={props.IDAdquisitionItem ? props.IDAdquisitionItem : bean.IDAdquisitionItem} onChage={(item: any) => {
                    setBean({ ...bean, IDAdquisitionItem: item.IDAdquisitionItem, TotalArticle: item.TotalArticle, IDLnFunctionalID: item.IDLnFunctionalID, IDProject: item.IDProject, });
                    console.log(item)
                }} />
            </div>

            {bean.IDAdquisitionItem &&
                <BasicTable head={head} body={_budget.lista} rowSet={_budget.setBean} />
            }

            <div className="col-md-12">
                <label>Justifiación:</label>
                <textarea placeholder="Observación minimo 15 caracteres" className={`form-control ${invalid ? "is-invalid" : ""}`} onBlur={() => { setInvalid(false) }} value={bean.obs} onChange={(e) => { setBean({ ...bean, "obs": e.target.value }) }} />
            </div>

            <div className="col-md-12">

                <div className="row mt-4 ">
                    <div className="col-md-6">
                        <BasicButton disable={bean.obs?.length < 16 && bean.IDAdquisitionItem} children={"Continuar"} eventClick={() => {
                            if (bean.obs.length > 15) {
                                saveSupplier()
                            } else {
                                setInvalid(true)
                                toast.error("La observacion debe tener un minimo de 15 caracteres")
                            }
                        }} icon="ri-save-line" />
                    </div>
                </div>
            </div>
        </div>
    )
}